import { render, staticRenderFns } from "./MessageIncidence.vue?vue&type=template&id=2ca14f87"
import script from "./MessageIncidence.vue?vue&type=script&lang=js"
export * from "./MessageIncidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports